import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function PaymentSuccessPage() {
    return (
        <div className="min-h-[70vh] flex items-center justify-center px-4" data-testid="payment-success-page">
            <div className="max-w-md w-full text-center bg-white rounded-2xl border border-slate-100 shadow-sm p-8">
                <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-5">
                    <CheckCircle2 className="w-9 h-9 text-green-600" />
                </div>
                <h1 className="text-2xl font-bold text-slate-900 mb-2">Payment received</h1>
                <p className="text-slate-600 mb-6">
                    Thank you! Your payment has been processed successfully. We'll get your order dispatched
                    and on its way to you shortly.
                </p>
                <Button asChild className="bg-[#1B4D3E] hover:bg-[#143a2f] rounded-full px-6">
                    <Link to="/" data-testid="payment-success-home-btn">Back to Home</Link>
                </Button>
            </div>
        </div>
    );
}
